import React from 'react';
import config from '../../config'
import { HTMLTrans, withTranslation } from '../Common/Translations';

const goTo = () => {
  window.location.href = config.voucherWalletOneLink
}

const AppPushPageContainer = () => {
  return (
    <div className='dashboard-card p-3 p-lg-5'>
      <div className='container px-0'>
        <h3>
          <span className='ProximaNova-Bold'>
            <HTMLTrans id="app_push_page.title">It seems like you have entered an App voucher.</HTMLTrans>
          </span>
        </h3>
        <p>
          <span className='ProximaNova'>
            <HTMLTrans id="app_push_page.description">Your app voucher has been stored, however, to view and use this voucher, please proceed to Photobook App.</HTMLTrans>
          </span>
        </p>
        <div className="col-lg-3 col-md-12 pl-0">
          <button type="button"
              className='btn btn-primary btn-block'
              onClick={goTo}>
            <HTMLTrans id="app_push_page.open_app_button">Open Photobook App</HTMLTrans>
          </button>
        </div>
      </div>
    </div>
  );
};

export default withTranslation('app_push_page')(AppPushPageContainer);



// WEBPACK FOOTER //
// ./src/AppPushPage/AppPushPageContainer.js